import React from 'react';
import { Scroll, Crown, Gem, Castle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const VillaStory = () => {
  const { t } = useLanguage();
  const icons = [Scroll, Crown, Gem, Castle];
  const features = t('villaStory.features');

  return (
    <section className="villa-story-section">
      <div className="container-custom">
        <div className="story-grid">
          <div className="story-content">
            <div className="section-badge">{t('villaStory.badge')}</div>
            <h2 className="section-title">{t('villaStory.title')}</h2>
            <div className="story-text">
              <p dangerouslySetInnerHTML={{ __html: t('villaStory.p1') }} />
              <p dangerouslySetInnerHTML={{ __html: t('villaStory.p2') }} />
              <p dangerouslySetInnerHTML={{ __html: t('villaStory.p3') }} />
              <p dangerouslySetInnerHTML={{ __html: t('villaStory.p4') }} />
            </div>
          </div>

          <div className="story-images">
            <div className="story-image-main">
              <img
                src="/villa-images/dan-9.jpg"
                alt="Villa in Pietra - aerial view"
              />
            </div>
          </div>
        </div>

        <div className="heritage-integrated">
          <div className="heritage-divider">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="30" cy="30" r="29" stroke="currentColor" strokeWidth="1" opacity="0.2"/>
              <path d="M20 30 C20 30, 25 20, 35 20 C45 20, 50 25, 50 35" stroke="currentColor" strokeWidth="1.5" fill="none"/>
            </svg>
          </div>

          <div className="text-center mb-12">
            <div className="section-badge">{t('villaStory.heritageBadge')}</div>
            <h2 className="section-title">{t('villaStory.heritageTitle')}</h2>
            <p className="section-description">{t('villaStory.heritageDesc')}</p>
          </div>

          <div className="heritage-features-compact">
            {Array.isArray(features) && features.map((feature, index) => {
              const IconComponent = icons[index];
              return (
                <div key={index} className="heritage-compact-card">
                  <div className="heritage-icon-wrapper-compact">
                    <IconComponent className="heritage-icon-compact" />
                  </div>
                  <h3 className="heritage-compact-title">{feature.title}</h3>
                  <p className="heritage-compact-description">{feature.description}</p>
                </div>
              );
            })}
          </div>

          <div className="heritage-showcase-compact">
            <div className="heritage-showcase-row">
              <img src="https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/soiw4e8z_BAJKINI%20-%2027.jpg" alt="16th-century hunting tapestry" />
              <img src="https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/y8hnbjpe_Detalji%20-%2011.jpg" alt="Roman column capital" />
              <img src="https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/rtki0pbo_Detalji%20-%2028.jpg" alt="Medieval maritime tapestry" />
              <img src="https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/svh1fqtk_Detalji%20-%2033.jpg" alt="Ancient amphora" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
